import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Howl } from 'howler';
@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.scss'],
})
export class AudioPlayerComponent implements OnInit {

  @Input() url: string = ''
  @Input() name?: string = ''
  @Input() blob?: boolean = false
  sound: any
  isplaying: boolean = false
  range: any
  duration: any = '00:00'
  currentDuration: any = '00:00'
  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  ionViewWillEnter() {
    this.sound = new Howl({
      src: [this.url],
      preload: true,
      html5: this.blob,
      volume: 0.5,
      format: ['mp3', 'm4a','wav'],
      onloaderror: (id: any, msg: any) => {
        console.error(id, String(msg));
      },
      onplayerror: (id: any, msg: any) => {
        console.error(id, String(msg));
      },
      onend: () => {
        this.isplaying = false
        if(this.blob)   URL.revokeObjectURL(this.url)
      },
      onload: () => {
        this.duration = this.formatTime(Math.round(this.sound.duration()));
      },
    });

  }
  close() {
    this.modalController.dismiss();
    this.sound.stop()
    this.isplaying = false
  }
  ngOnDestroy() {
    this.sound.stop()
    this.isplaying = false
  }
  play() {
    this.isplaying = true
    this.sound.play();
    this.seekbarloop()
  }
  formatTime(secs) {
    var minutes = Math.floor(secs / 60) || 0;
    var seconds = (secs - minutes * 60) || 0;

    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
  }
  skipForward = () => {
    const currentPosition = this.sound.seek();
    const newPosition = currentPosition + 10;

    if (newPosition < this.sound.duration()) {
      this.sound.seek(newPosition);
    }
  };
  skipBack = () => {
    const currentPosition = this.sound.seek();
    const newPosition = currentPosition - 10;

    if (newPosition < this.sound.duration() && newPosition > 0) {
      this.sound.seek(newPosition);
    } else {
      this.sound.seek(0)
    }
  };
  pause() {
    this.isplaying = false
    this.sound.pause()
  }
  stop() {
    this.sound.stop()
    this.isplaying = false
  }

  seekbarloop() {
    var currentscond = this.sound.seek()
    if (this.isplaying) {
      this.range = currentscond / this.sound.duration() * 100

      var seek = this.sound.seek() || 0;
      this.currentDuration = this.formatTime(Math.round(seek));

      setTimeout(() => {
        this.seekbarloop()
      }, 1000)
    }
  }
  rangeChanged(ev) {
    var wantedsecond = (ev.target.value * this.sound.duration()) / 100
    this.sound.seek(wantedsecond)
    if (!this.isplaying) {
      var seek = this.sound.seek() || 0;
      this.currentDuration = this.formatTime(Math.round(seek));
    }

  }
}
